import { Card, TimePicker } from "antd";
import dayjs from "dayjs";
interface Props {
  data: any;
  viewOnly?: boolean;
}
export default function DetailsTemplateTime({ data, viewOnly }: Props) {
  return (
    <>
      <Card className="mt-4">
        <div className="self-stretch justify-start text-zinc-700 text-base font-medium">
          Time - {data?.question_title}
        </div>

        <div className="flex flex-col gap-1 mt-4">
          <label className="text-gray-600 text-sm">Time</label>

          <div className="min-w-[300px]">
            <TimePicker
              disabled={viewOnly}
              value={
                data?.answer
                  ? dayjs(data?.answer, ["hh:mm A", "hh:mm A"])
                  : null
              }
              use12Hours
              format="hh:mm A"
              placeholder="hh:mm AM"
              className="border-0 border-b border-slate-400 rounded-none min-w-[300px] px-0 text-gray-600 placeholder:text-gray-400 focus:shadow-none focus:border-slate-600"
            />
          </div>
        </div>
      </Card>
    </>
  );
}
